import { render, staticRenderFns } from "./categoryMap.vue?vue&type=template&id=53a07a34&scoped=true&"
import script from "./categoryMap.vue?vue&type=script&lang=js&"
export * from "./categoryMap.vue?vue&type=script&lang=js&"
import style0 from "./categoryMap.vue?vue&type=style&index=0&id=53a07a34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a07a34",
  null
  
)

export default component.exports